import { Map } from 'immutable';

export const TYPES = {
  GET_DASHBOARD_LIST: 'GET_DASHBOARD_LIST',
  GET_DASHBOARD_LIST_SUCCESS: 'GET_DASHBOARD_LIST_SUCCESS',
  SET_CPU_USAGE: 'SET_CPU_USAGE',
  SET_MEMORY_USAGE: 'SET_MEMORY_USAGE',
  SET_TRAFFIC_IN: 'SET_TRAFFIC_IN',
  SET_TRAFFIC_OUT: 'SET_TRAFFIC_OUT',
};

const initState = Map({
  dashboard: [],
  cpuUsage: [],
  memoryUsage: [],
  trafficIn: [],
  trafficOut: [],
});
const MAX = 10;

export default function DashboardReducer(state = initState, action) {
  switch (action.type) {
    case TYPES.GET_DASHBOARD_LIST_SUCCESS:
      return state.set('dashboard', action.prod);
    case TYPES.SET_CPU_USAGE:
      const newCpuUsage = [...state.get('cpuUsage'), ...action.cpuUsage];

      if (newCpuUsage?.length > MAX) {
        newCpuUsage.shift();
      }
      return state.set('cpuUsage', newCpuUsage);
    case TYPES.SET_MEMORY_USAGE:
      const newMemoryUsage = [
        ...state.get('memoryUsage'),
        ...action.memoryUsage,
      ];

      if (newMemoryUsage?.length > MAX) {
        newMemoryUsage.shift();
      }
      return state.set('memoryUsage', newMemoryUsage);
    case TYPES.SET_TRAFFIC_IN:
      const newTrafficIn = [...state.get('trafficIn'), ...action.trafficIn];

      if (newTrafficIn?.length > MAX) {
        newTrafficIn.shift();
      }
      return state.set('trafficIn', newTrafficIn);
    case TYPES.SET_TRAFFIC_OUT:
      const newTrafficOut = [...state.get('trafficOut'), ...action.trafficOut];

      if (newTrafficOut?.length > MAX) {
        newTrafficOut.shift();
      }
      return state.set('trafficOut', newTrafficOut);

    default:
      return state;
  }
}

export const actions = {
  getDashboardList: ({ param }) => ({ type: TYPES.GET_DASHBOARD_LIST, param }),
  setCpuUsage: ({ cpuUsage }) => ({ type: TYPES.SET_CPU_USAGE, cpuUsage }),
  setMemoryUsage: ({ memoryUsage }) => ({
    type: TYPES.SET_MEMORY_USAGE,
    memoryUsage,
  }),
  setTrafficIn: ({ trafficIn }) => ({ type: TYPES.SET_TRAFFIC_IN, trafficIn }),
  setTrafficOut: ({ trafficOut }) => ({
    type: TYPES.SET_TRAFFIC_OUT,
    trafficOut,
  }),
};
